import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// services
import * as TransactionService from '_services/transaction-service';

const initialState = {
    userTransaction: {},

    savedTransaction: null,
    saveTransactionStatus: 'idle',
    saveTransactionError: null,

    status: 'idle',
    error: null
};

export const saveTransaction = createAsyncThunk('userTransaction/saveTransaction', async (transactionObject) => {
    return TransactionService.saveTransaction(transactionObject);
})

const userTransactionSlice = createSlice({
    name: 'userTransaction',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [saveTransaction.pending]: (state) => {
            state.saveTransactionStatus = 'loading';
            state.saveTransactionError = null;
            state.savedTransaction = null;
        },
        [saveTransaction.fulfilled]: (state, action) => {
            state.saveTransactionStatus = 'succeeded';
            state.savedTransaction = action.payload;
        },
        [saveTransaction.rejected]: (state, action) => {
            state.saveTransactionStatus = 'failed';
            state.saveTransactionError = action.error.message;
        }
    }
});

export const { reset } = userTransactionSlice.actions;

// selectors
export const selectUserSavedTransaction = (state) => state.userTransaction.savedTransaction;
export const selectUserTransactionStatus = (state) => state.userTransaction.saveTransactionStatus;
export const selectUserTransactionError = (state) => state.userTransaction.saveTransactionError;
export const selectUserTransaction = (state) => state.userTransaction.userTransaction;

export default userTransactionSlice.reducer;
